import Icon from "@ant-design/icons/lib/components/Icon";
import { Image, Spacing } from "@p0security/ui";
import React, { useCallback } from "react";

import { useScreen } from "../../../hooks/useScreen";

export const P0NavIcon: React.FC = () => {
  const { isDesktop } = useScreen();
  const component = useCallback(
    () =>
      isDesktop ? (
        <Spacing mt={10}>
          <Image
            preview={false}
            src={"/p0-logomark-dark.svg"}
            alt="P0"
            width={160}
          />
        </Spacing>
      ) : (
        <Spacing mt={10} ml={-20}>
          <Image
            preview={false}
            src={"/p0-small-logomark-dark.svg"}
            alt="P0"
            width={40}
            height={30}
          />
        </Spacing>
      ),
    [isDesktop]
  );

  return <Icon component={component} />;
};
